// Explore.jsx

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HowItWorksSlide from "./Slides/slide1";
import MainChatSlide from "./Slides/slide2";
import ReflectionCards from './Slides/slide3';
import AiCompanionSlide from './Slides/slide4';
import EmotionSlide from './Slides/slide5';
import ButtonSlide from './Slides/slide6';
import ChatSlide from './Slides/slide7';

export default function Explore() {
  const slides = [
    <HowItWorksSlide  />,
    <MainChatSlide />,
    <AiCompanionSlide/>,
    <EmotionSlide/>,
    <ButtonSlide/>,
    <ChatSlide/>,
    <ReflectionCards/>
  ];
  const [touchStart, setTouchStart] = useState(0);
const [touchEnd, setTouchEnd] = useState(0);
  const [current, setCurrent] = useState(0);
  const totalSlides = slides.length;
  const navigate = useNavigate();
 
  const nextSlide = () => {
  setCurrent((prev) => (prev + 1) % totalSlides);
};

const prevSlide = () => {
  setCurrent(
    (prev) => (prev - 1 + totalSlides) % totalSlides
  );
};
useEffect(() => {
  const handleKey = (e) => {
    if (e.key === "ArrowRight") {
      nextSlide();
    }

    if (e.key === "ArrowLeft") {
      prevSlide();
    }
  };

  window.addEventListener("keydown", handleKey);

  return () => {
    window.removeEventListener(
      "keydown",
      handleKey
    );
  };
}, []);
  return (
    <>
      <style>{`
        @keyframes exploreSlide {
          0%{
            opacity:0;
            transform:translateX(100px);
          }

          100%{
            opacity:1;
            transform:translateX(0px);
          }
        }

        .explore-slider{
          width:100%;
          animation: exploreSlide 0.8s cubic-bezier(0.22,1,0.36,1);
        }

        .explore-dot{
          width:10px;
          height:10px;
          border-radius:50%;
          background:rgba(201,168,76,0.18);
          transition:all 0.3s ease;
        }

        .explore-dot.active{
          width:32px;
          border-radius:999px;
          background:var(--gold);
        }
      `}</style>


<div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "18px",
    flexWrap: "wrap",
    padding: "30px",
  }}
>
  {/* back */}
  <button
    onClick={()=>{
        navigate('/')
    }}
    style={{
      padding: "14px 28px",
      borderRadius: "999px",
      border: "1px solid rgba(201,168,76,0.18)",
      background: "rgba(201,168,76,0.03)",
      color: "var(--parch)",
      fontFamily: "var(--fell)",
      fontSize: "12px",
      letterSpacing: "2px",
      cursor: "pointer",
      transition: "all 0.35s ease",
    }}
    onMouseEnter={(e) => {
      e.target.style.background =
        "rgba(201,168,76,0.08)";
      e.target.style.borderColor =
        "rgba(201,168,76,0.35)";
    }}
    onMouseLeave={(e) => {
      e.target.style.background =
        "rgba(201,168,76,0.03)";
      e.target.style.borderColor =
        "rgba(201,168,76,0.18)";
    }}
  >
    ← BACK
  </button>

  {/* signup */}
  <button
    onClick={() => navigate("/auth")}
    style={{
      padding: "14px 34px",
      borderRadius: "999px",
      border: "1px solid rgba(201,168,76,0.28)",
      background: "var(--gold)",
      color: "#080604",
      fontFamily: "var(--fell)",
      fontSize: "12px",
      letterSpacing: "2px",
      cursor: "pointer",
      transition: "all 0.35s ease",
      boxShadow:
        "0 10px 30px rgba(201,168,76,0.15)",
    }}
    onMouseEnter={(e) => {
      e.target.style.transform =
        "translateY(-3px)";
    }}
    onMouseLeave={(e) => {
      e.target.style.transform =
        "translateY(0px)";
    }}
  >
    SIGN UP
  </button>
</div>
      <div
        style={{
          minHeight: "100vh",
          background: "#080604",
          color: "#e8dcc8",
          overflow: "hidden",
          padding: "0px 40px 80px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* heading */}
      
{/* carousel wrapper */}
<div
  className="explore-slider"
  style={{
    position: "relative",
    width: "100%",
  }}
  onTouchStart={(e) =>
    setTouchStart(e.targetTouches[0].clientX)
  }
  onTouchMove={(e) =>
    setTouchEnd(e.targetTouches[0].clientX)
  }
  onTouchEnd={() => {
    if (touchStart - touchEnd > 50) nextSlide();
    if (touchEnd - touchStart > 50) prevSlide();
  }}
>
  {/* LEFT ARROW */}
  <button
    onClick={prevSlide}
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      background: "rgba(0,0,0,0.4)",
      border: "1px solid rgba(201,168,76,0.25)",
      color: "var(--gold)",
      width: "44px",
      height: "44px",
      borderRadius: "50%",
      cursor: "pointer",
      fontSize: "18px",
    }}
  >
    ‹
  </button>

  {/* SLIDE */}
  {slides[current]}

  {/* RIGHT ARROW */}
  <button
    onClick={nextSlide}
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      background: "rgba(0,0,0,0.4)",
      border: "1px solid rgba(201,168,76,0.25)",
      color: "var(--gold)",
      width: "44px",
      height: "44px",
      borderRadius: "50%",
      cursor: "pointer",
      fontSize: "18px",
    }}
  >
    ›
  </button>
</div>
</div>
      
    </>
  );
}